import { makeStyles } from "@material-ui/core";
import React from "react";
import { ArrayInput, TextInput, required, useTranslate } from "react-admin";

import SimpleFormIteratorEx from "../../../components/_extensions/react-admin/ra-ui-materialui/src/form/SimpleFormIteratorEx";
import { validateUnique } from "../../../utils/validation/general";

const useArrayInputStyle = makeStyles(() => ({
	root: {
		"& div.ra-input": {
			display: "inline-block",
			marginLeft: "0.7em",
		},
	},
}));

const validateMapperCustomValue = (value, values) => {
	const result = values.data.find(item => item.value === value);
	if (result.key === "custom" && value){
		const pattern = /^\s*([^\s:,][^:,]*\s*:\s*[^\s:,][^:,]*\s*:\s*[^\s:,][^:,]*)(\s*,\s*[^\s:,][^:,]*\s*:\s*[^\s:,][^:,]*\s*:\s*[^\s:,][^:,]*)*\s*$/;
		if(!pattern.test(value)){
			return "osfc.messages.validation.validateMapperCustomValue";
		}
	}

	const allowedTypes = ["int", "str", "float", "datetime"];
	const entries = value.split(",").map((entry) => entry.trim());
	if (result.key === "custom" && value){
		for (const entry of entries) {
			const parts = entry.split(":").map(p => p.trim());

			const type = parts[1];
			if (!allowedTypes.includes(type)) {
				return "osfc.messages.validation.invalidType";
			}
		}
	}
};


export const MapperDataInput = (props) => {
	const arrayInputClasses = useArrayInputStyle();

	return (
		<>
			<ArrayInput {...props}>
				<SimpleFormIteratorEx classes={arrayInputClasses}>
					<TextInput
						source="key"
						label="resources.mappers.fields.data_field.key"
						validate={[required(), validateUnique("key")]}
					/>
					<TextInput
						source="value"
						label="resources.mappers.fields.data_field.value"
						validate={required()}
					/>
				</SimpleFormIteratorEx>
			</ArrayInput>
		</>
	);
};

export const MapperDataInputPredefined = ({ optionalKeys, formData, ...rest }) => {
	const translate = useTranslate();
	const arrayInputClasses = useArrayInputStyle();
	console.log(optionalKeys);

	const getValidator = (record, member, index, input, index2) => {
		if (
			input.props.source === "value" &&
			optionalKeys.indexOf(formData["data"][index]["key"]) === -1
		)
			return required();
	};

	return (
		<>
			<ArrayInput {...rest}>
				<SimpleFormIteratorEx
					classes={arrayInputClasses}
					disableAdd
					disableRemove
					disableReordering
					getValidator={optionalKeys && getValidator}
				>
					<TextInput
						style={{ width: "350px" }}
						source="key"
						label="resources.mappers.fields.data_field.key"
						validate={[required(), validateUnique("key")]}
						disabled
						format={(val) => translate(`resources.mappers.fields.data_field.${val}`) + ` (${val})`}
						parse={(v) => (v === undefined ? "" : v)}
					/>
					<TextInput
						style={{ width: "350px" }}
						source="value"
						label="resources.mappers.fields.data_field.value"
						parse={(v) => (v === undefined ? "" : v)}
						validate={validateMapperCustomValue}
					/>
				</SimpleFormIteratorEx>
			</ArrayInput>
		</>
	);
};
